import { render, staticRenderFns } from "./ApplyCourseAdditionalQuestions.vue?vue&type=template&id=50a514d6&"
import script from "./ApplyCourseAdditionalQuestions.vue?vue&type=script&lang=ts&"
export * from "./ApplyCourseAdditionalQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports